<template>
  <div>
    <v-row>
      <v-col cols="12" class="prueba">
        <v-sheet max-width="auto">
          <v-slide-group
            v-model="model"
            active-class="success"
            show-arrows
            center-active
          >
            <v-slide-item
              v-for="(product, i) in products.slice(0, 20)"
              :key="i"
            >
              <cardProduct
                class="ml-3 mt-2 mb-5 mr-1"
                v-bind:product="product"
                :sendSnack="sendSnack"
              >
              </cardProduct>
            </v-slide-item>
          </v-slide-group>
        </v-sheet>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import cardProduct from "./../product/child_cardProduct.vue";

export default {
  name: "child_relatedProduct",

  components: {
    cardProduct,
  },

  data() {
    return {
      model: null,
      title: "",
    };
  },

  props: {
    products: { type: Array },
    similar: { type: Boolean },
    sendSnack: { type: Function },
  },

  methods: {},

  computed: {},

  watch: {},

  created: function () {},

  mounted() {},
};
</script>

<style>
.prueba {
  font-size: 0.95rem;
  margin: 5px 0;
  line-height: 14px;
}
</style>
